const COMMON_MORPHS = {
  a: ["a", "aa", "vrc_v_aa"],
  e: ["e", "ee", "vrc_v_ee"],
  o: ["o", "oh", "vrc_v_oh"],
  blink: ["blink", "blink_l", "blink_r", "vrc_blink"],
  joy: ["joy", "happy"],
  sorrow: ["sorrow", "sad"],
  angry: ["angry"],
};

export const AVATAR_CHARACTERS = {
  botbunny: {
    id: "botbunny",
    name: "BotBunny",
    note: "Best AIHumanity fit",
    assetUrl: "/models/avatars/botbunny.vrm",
    previewUrl: "/models/avatars/botbunny-preview.jpg",
    sourceUrl: "https://github.com/ToxSam/open-source-avatars",
    license: "CC0-1.0",
    morphs: COMMON_MORPHS,
    expressions: ["joy", "sorrow", "angry"],
    lipSync: {
      sequence: ["a", "e", "o", "a", "o", "e"],
      shapesPerSecond: 8.5,
    },
    pose: {
      LeftArm: [0, 0, 1.05],
      RightArm: [0, 0, -1.05],
    },
    voiceFraming: {
      camera: [0, 1.47, 1.75],
      target: [0, 1.47, 0],
      position: [0, 0, 0],
      rotation: [0, Math.PI, 0],
      scale: 1,
    },
  },
  dogoburger: {
    id: "dogoburger",
    name: "DogoBurger",
    note: "Most adorable",
    assetUrl: "https://arweave.net/qKrAwFf60cT1348kvQc7S5Nzn3fO0aNvJ8ybMx5Lu04",
    previewUrl: "https://arweave.net/ACJ5aRaOVmhhcXsqpgdm7lkSeHXqK6vXZCX67mwNoec",
    sourceUrl: "https://github.com/ToxSam/open-source-avatars",
    license: "CC0-1.0",
    morphs: COMMON_MORPHS,
    expressions: ["joy", "sorrow", "angry"],
    lipSync: {
      sequence: ["a", "e", "o", "a", "o"],
      shapesPerSecond: 8,
    },
  },
  dinokid: {
    id: "dinokid",
    name: "DinoKid",
    note: "Best phoneme coverage",
    assetUrl: "https://arweave.net/T1gkB95XKXAZl_VmU1ozg5Txm--o9nY0Nge3s8zNoBs",
    previewUrl: "https://arweave.net/qRNTQjqGS9WiZUr-_dpKOBPyM9a6ucbBpRq_5yiz9lY",
    sourceUrl: "https://github.com/ToxSam/open-source-avatars",
    license: "CC0-1.0",
    morphs: {
      ...COMMON_MORPHS,
      a: [...COMMON_MORPHS.a, "3"],
      e: [...COMMON_MORPHS.e, "6"],
      o: [...COMMON_MORPHS.o, "11"],
      blink: [...COMMON_MORPHS.blink, "0"],
    },
    expressions: [],
    lipSync: {
      sequence: ["a", "e", "o", "a", "o", "e"],
      shapesPerSecond: 9,
    },
  },
};

export const DEFAULT_VOICE_CHARACTER_ID = "botbunny";

export const AVATAR_CHARACTER_LIST = Object.values(AVATAR_CHARACTERS);

export function getAvatarCharacter(id = DEFAULT_VOICE_CHARACTER_ID) {
  return AVATAR_CHARACTERS[id] || AVATAR_CHARACTERS[DEFAULT_VOICE_CHARACTER_ID];
}
